import { Component, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Moment } from 'moment-timezone';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatOptionModule } from '@angular/material/core';

@Component({
  selector: 'app-zone-modal',
  templateUrl: './timezone-modal.component.html',
  styleUrls: ['./timezone-modal.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    TranslateModule,
    MatOptionModule,
  ],
})
export class TimezoneModalComponent {
  dialogRef = inject<MatDialogRef<TimezoneModalComponent>>(MatDialogRef);
  data = inject<{
    moment: Moment;
    zonesList: {
      label: string;
      zoneName: string;
      cities: string;
      zoneTime: number;
    }[];
    currentZone: string;
  }>(MAT_DIALOG_DATA);

  public selectZone: string;

  constructor() {
    const data = this.data;

    this.selectZone = data.currentZone;
  }

  onConfirm() {
    this.dialogRef.close({
      timezone: this.selectZone,
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
